export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '所属险种',
		dataIndex: 'insuranceType',
		align: 'center',
		scopedSlots: { customRender: 'insuranceType' },
	},
	{
		title: '录单日期',
		align: 'center',
		dataIndex: 'createTime',
		key: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '任务类型',
		align: 'center',
		dataIndex: 'taskType',
		key: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '订单类型',
		align: 'center',
		dataIndex: 'orderType',
		key: 'orderType',
		scopedSlots: { customRender: 'orderType' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
		key: 'orderNo',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
		key: 'caseNo',
	},
	// {
	// 	title: '车主/报案人姓名',
	// 	align: 'center',
	// 	dataIndex: 'ownerName',
	// 	key: 'ownerName',
	// },
	// {
	// 	title: '伤者姓名',
	// 	align: 'center',
	// 	dataIndex: 'injuredName',
	// },
	{
		title: '作业所在地区',
		width: 200,
		align: 'center',
		dataIndex: 'location',
		key: 'location',
	},
	{
		title: '订单状态',
		align: 'center',
		dataIndex: 'orderStatus',
		key: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '业务线',
		align: 'center',
		dataIndex: 'businessLineDesc',
		key: 'businessLineDesc',
		auth: 'dataPermission:businessLine', // 数据权限控制标识
	},
	{
		title: '结算状态',
		align: 'center',
		dataIndex: 'settleStatusDesc',
		key: 'settleStatusDesc',
		// scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '发票号',
		align: 'center',
		dataIndex: 'invoices',
		key: 'invoices',
		auth: 'dataPermission:invoices', // 数据权限控制标识
		// scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
